import React, { FC } from 'react'
import { IShipmentIssue, IShipmentIssueStates, IShipmentIssueType } from 'types/graphqlTypes'
import { FunctionalTag, IFunctionalTagOption, TAG_SIZE } from 'transfix-ui'
import { statusSelectList } from '../../../ShipmentIssues/constants'
import { TOnSubmitField } from './types'
import { canIssueManuallyResolve } from './utils'

interface IShipmentStatusIssue extends Pick<IShipmentIssue, 'state'> {
  type: Pick<IShipmentIssueType, 'canManuallyResolve' | 'categoryId' | 'id'>
}

interface ISelectStatusProps {
  issue: IShipmentStatusIssue
  onChange: TOnSubmitField
  size?: TAG_SIZE
}

/**
 * Set status of issue
 */
export const SelectStatus: FC<ISelectStatusProps> = ({
  issue,
  onChange,
  size = TAG_SIZE.small,
}) => {
  const { state, type: issueType } = issue || {}
  const selectStatusHandler = (a: IFunctionalTagOption<string>) => {
    onChange({
      state: a.value as IShipmentIssueStates,
    })
  }
  const canManuallyResolve = canIssueManuallyResolve(issueType)

  const availableStatuses = statusSelectList.map(
    ({ description, label, outlineOnly, style, value: listValue }) => ({
      value: listValue,
      label,
      description,
      disabled: !canManuallyResolve && [state, listValue].includes(IShipmentIssueStates.resolved),
      style,
      outlineOnly,
    })
  )

  return (
    <FunctionalTag
      id='select-status'
      dataTest='select-status'
      value={state}
      options={availableStatuses}
      onSelect={selectStatusHandler}
      renderType='withDescription'
      size={size}
    />
  )
}

export default SelectStatus
